export default "__VITE_ASSET__BeAQIdKS__"